import http from "./http";

class PeriodicitesService {
    index(token){
        return http.get("/api/periodicites",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    store(data,token){
        return http.post("/api/periodicites/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/periodicites/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/periodicites/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/periodicites/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/periodicites/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new PeriodicitesService()